var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator"},[_c('span',{style:({color: _vm.textColor})},[_vm._v(_vm._s(_vm.loadingText))]),_c('v-progress-circular',{attrs:{"size":30,"width":3,"value":100,"color":_vm.loadingColor,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }